__turbopack_context__.v({
  "content": "Collapsible-module__MMUxlW__content",
  "open": "Collapsible-module__MMUxlW__open",
  "toggleBtn": "Collapsible-module__MMUxlW__toggleBtn",
  "toggleBtnMax": "Collapsible-module__MMUxlW__toggleBtnMax",
  "trigger": "Collapsible-module__MMUxlW__trigger",
  "triggerDefault": "Collapsible-module__MMUxlW__triggerDefault",
  "triggerTree": "Collapsible-module__MMUxlW__triggerTree",
});
